import React, { useState, useRef } from 'react';

const TEAM_LOGOS = [
  {
    name: 'Patriots',
    src: 'https://a.espncdn.com/combiner/i?img=/i/teamlogos/nfl/500/ne.png',
    tx: '-52px', ty: '-68px', rot: '-28deg', delay: '0ms',
  },
  {
    name: 'Celtics',
    src: 'https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/bos.png',
    tx: '0px', ty: '-88px', rot: '0deg', delay: '60ms',
  },
  {
    name: 'Red Sox',
    src: 'https://a.espncdn.com/combiner/i?img=/i/teamlogos/mlb/500/bos.png',
    tx: '52px', ty: '-68px', rot: '28deg', delay: '30ms',
  },
];

const Hero = () => {
  const [catVisible, setCatVisible] = useState(false);
  const [sportsVisible, setSportsVisible] = useState(false);
  const catTimer = useRef(null);
  const sportsTimer = useRef(null);

  const handleCatClick = () => {
    setCatVisible(true);
    if (catTimer.current) clearTimeout(catTimer.current);
    catTimer.current = setTimeout(() => setCatVisible(false), 2000);
  };

  const handleSportsClick = () => {
    setSportsVisible(true);
    if (sportsTimer.current) clearTimeout(sportsTimer.current);
    sportsTimer.current = setTimeout(() => setSportsVisible(false), 2500);
  };

  return (
    <section className="hero-section" id="about">
      <div className="container">
        <h1 className="hero-name">andy siegel</h1>
        <p className="hero-role">software engineer</p>
        <p className="hero-bio">
          cs senior at the university of arizona, math minor.<br />
          esports player,{' '}
          <span className="cat-trigger" onClick={handleSportsClick}>
            sports geek
            {sportsVisible && (
              <span className="sports-logos">
                {TEAM_LOGOS.map((team) => (
                  <img
                    key={team.name}
                    src={team.src}
                    alt={team.name}
                    className="sports-logo"
                    style={{
                      '--tx': team.tx,
                      '--ty': team.ty,
                      '--rot': team.rot,
                      animationDelay: team.delay,
                    }}
                  />
                ))}
              </span>
            )}
          </span>,{' '}
          <span className="cat-trigger" onClick={handleCatClick}>
            cat person
            <span className={`cat-popup${catVisible ? ' visible' : ''}`}>
              {` /\\_/\\  \n( o.o ) \n > ^ <`}
            </span>
          </span>.<br />
          building things i use every day.
        </p>
      </div>
    </section>
  );
};

export default Hero;
